<div class="d-flex gap-8 flex-grow-1 flex-direction-column packages">
  <table class="base full-width table-layout-fixed">
    <thead>
    <tr>
      <th width="40%">
        {{ 'Name'| trans:'package-search/table/name.Text' }}
      </th>
      <th width="15%" class="text-right">
        {{ 'Preis'| trans:'package-search/table/price.Text' }}
      </th>
      <th width="15%">
        {{ 'Währung'| trans:'package-search/table/currency.Text' }}
      </th>
    </tr>
    </thead>
    <tbody [class.has-selected]="selectedPackage">
      @for (p of packages; track p.id) {
        <tr
          class="selectable-tr cursor-pointer"
          [class.selected]="selectedPackage?.id === p.id && selectedPackage?.priceAreaId === p.priceAreaId"
          (click)="selectPackage(p)"
        >
          <td>
            <div class="white-space-nowrap overflow-hidden text-overflow-ellipsis">
              {{ p.name }}
            </div>
          </td>
          <td>
            <div class="white-space-nowrap overflow-hidden text-overflow-ellipsis text-right">
              {{ p.totalPrice | numberToCurrency }}
            </div>
          </td>
          <td>
            <div class="white-space-nowrap overflow-hidden text-overflow-ellipsis">
              {{ p.currency }}
            </div>
          </td>
        </tr>
      }
    </tbody>
  </table>
</div>
